import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=c57c4318&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=c57c4318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57c4318",
  null
  
)

export default component.exports